import {
  AQSI_CAPABILITY_HINTS,
  AQSI_CAPABILITY_LABELS,
  AQSI_KIND,
  AQSI_TITLE,
  emptyAqsiSettings,
  validateAqsiSettings,
} from './model/settings'
import { AqsiConnectionForm } from './ui/AqsiConnectionForm'

/**
 * Форма подключения кабинета AQSI для реестра Platform. Объект той же формы,
 * что `ConnectionFormExtension` пакета `platform-ui`: пакеты друг друга не
 * импортируют, совместимость проверяет компилятор при регистрации в
 * `apps/web/src/composition/connectionForms.ts`.
 */
export const aqsiConnectionForm = {
  kind: AQSI_KIND,
  title: AQSI_TITLE,
  /** Метка вида на вкладках разделов (UI-SECTIONS). */
  shortTitle: 'AQSI',
  /** Слово вида на плитке источника РМК (UI-RMK-FLOW 3.4). */
  sourceNoun: 'Кабинет AQSI',
  /** Цвет вида — палитра источника ui-kit, та же, что у рамки окон пакета. */
  tone: 'aqsi',
  /** Строка на плитке окна «Добавить источник». */
  summary: 'Кабинет AQSI — касса, смены и чеки.',
  capabilityLabels: AQSI_CAPABILITY_LABELS,
  capabilityHints: AQSI_CAPABILITY_HINTS,
  // Права и модули вида — из манифеста с сервера; пакет вида даёт слова. Один модуль `main` называется как сам вид.
  secret: {
    label: 'Ключ кабинета AQSI',
    hint: 'Хранится на сервере зашифрованным и сюда не возвращается.',
    requiredOnCreate: true,
  },
  emptySettings: emptyAqsiSettings,
  validate: validateAqsiSettings,
  Form: AqsiConnectionForm,
} as const
